import { _ } from "libs";

import React from "react";
import { Route, NavLink } from "react-router-dom";
import Buddies from "../components/players/buddies";
import ClubPage from "../components/players/club";
import Everyone from "../components/players/everyone";

const Players = ({ history, match }) => {
	return (
		<div className="players hasSubheader">
			<div className="subheader">
				<div className="wrap">
					<ul>
						<li>
							<NavLink to="/players/buddies">{_("players.nav.buddies")}</NavLink>
						</li>
						<li>
							<NavLink to="/players/club">{_("players.nav.club")}</NavLink>
						</li>
						<li>
							<NavLink to="/players/everyone">{_("players.nav.everyone")}</NavLink>
						</li>
					</ul>
				</div>
			</div>
			<div className="wrap">
				<Route exact path="/players/buddies" component={Buddies} />
				<Route exact path="/players/club" component={ClubPage} />
				<Route exact path="/players/everyone" component={Everyone} />
			</div>
		</div>
	);
};

export default Players;
